import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../ui/button';
import { brand } from '../../config/brand';

export default function LandingNavbar(): JSX.Element {
    const token = localStorage.getItem('token');
    const location = useLocation();
    const activeClass = brand.defaultTheme === 'olive' ? 'text-gray-900' : 'text-white';
    const hoverClass = brand.defaultTheme === 'olive' ? 'hover:text-gray-900' : 'hover:text-white';

    const isPricing = location.pathname === '/pricing';
    const isSupport = location.pathname === '/support';

    return (
        <nav className="border-b border-border bg-background/80 backdrop-blur-md sticky top-0 z-[100]">
            <div className="container mx-auto h-16 flex items-center justify-between px-4">
                <div className="flex items-center gap-2">
                    <Link to="/" className="flex items-center gap-3 group">
                        <img src={brand.logo} alt={brand.name} className="h-9 w-auto transition-transform group-hover:scale-110" />
                        <span className="text-2xl font-brand tracking-tighter text-primary uppercase">
                            {brand.name}
                        </span>
                    </Link>
                </div>
                <div className="flex items-center gap-6">
                    <div className="hidden md:flex items-center gap-6 mr-2">
                        <Link
                            to="/pricing"
                            className={`text-sm font-bold transition-colors ${isPricing ? `${activeClass} border-b-2 border-primary pb-1 mt-1` : `text-muted-foreground ${hoverClass}`}`}
                        >
                            Pricing
                        </Link>
                        <Link
                            to="/support"
                            className={`text-sm font-bold transition-colors ${isSupport ? `${activeClass} border-b-2 border-primary pb-1 mt-1` : `text-muted-foreground ${hoverClass}`}`}
                        >
                            Support
                        </Link>
                    </div>
                    <div className="flex items-center gap-4">
                        {token ? (
                            <Button asChild className="bg-primary hover:bg-primary/90 text-primary-foreground font-black px-6 shadow-lg shadow-primary/20">
                                <Link to="/dashboard">Go To Dashboard</Link>
                            </Button>
                        ) : (
                            <>
                                <Button variant="ghost" asChild className="text-muted-foreground hover:text-primary hover:bg-primary/5">
                                    <Link to="/login">Login</Link>
                                </Button>
                                <Button asChild className="bg-primary hover:bg-primary/90 text-primary-foreground font-black px-6 shadow-lg shadow-primary/20 hidden sm:flex">
                                    <Link to="/login">Get Started</Link>
                                </Button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
}
